import { render, staticRenderFns } from "./CalendarNotificationIcon.vue?vue&type=template&id=a1f0e358&scoped=true&"
import script from "./CalendarNotificationIcon.vue?vue&type=script&lang=js&"
export * from "./CalendarNotificationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f0e358",
  null
  
)

export default component.exports